<template>
  <b-row>
    <b-col cols="12" md="8" xl="8">
      <transition name="slide">
      <b-card :header="caption">
        <div style="text-align:right;margin:0px 0px 10px 0px">
            <b-button variant="primary" size="sm" @click="postModal=true" v-b-tooltip.hover title="Add">
              <i class="fa fa-plus" ></i>&nbsp;ADD
            </b-button>
        </div>
        <div class="table-responsive">
          <table v-if="!isLoading"  aria-busy="false" aria-colcount="5" class="table b-table table-striped table-hover">
              <thead class="">
                  <tr>
                      <th aria-colindex="1" class="">#</th>
                      <th aria-colindex="2" class="">Title</th>
                      <th aria-colindex="5" class="">Action</th>
                  </tr>
              </thead>
              <!---->
              <tbody class="">
                <tr v-for="(item,index) in items.headline" >
                  <td>{{getNumber(index)}}</td>
                  <td>{{item.title}}</td>
                  <td>
                    <b-button size="sm" variant="danger" class="btn-sm" @click="deleteA(item.id,'headline')" v-b-tooltip.hover title="Delete"><i class="fa fa-trash"></i></b-button>
                  </td>
                </tr>
              </tbody>
          </table>
        </div>
        <square v-if="isLoading"></square>
       
      </b-card>
      </transition>
    </b-col>

    <b-col cols="12" md="4" xl="4">
      <transition name="slide">
      <b-card :header="'Headline Category'">

        <div style="text-align:right;margin:0px 0px 10px 0px">
            <b-button variant="primary" size="sm" @click="menuModal=true" v-b-tooltip.hover title="Add">
              <i class="fa fa-plus" ></i>&nbsp;ADD
            </b-button>
        </div>
        <div class="table-responsive">
          <table v-if="!isLoading"  aria-busy="false" aria-colcount="5" class="table b-table table-striped table-hover">
              <thead class="">
                  <tr>
                      <th aria-colindex="1" class="">#</th>
                      <th aria-colindex="2" class="">Category</th>
                      <th aria-colindex="5" class="">Action</th>
                  </tr>
              </thead>
              <!---->
              <tbody class="">
                <tr v-for="(item,index) in items.headline_category" >
                  <td>{{getNumber(index)}}</td>
                  <td>{{item.name}}</td>
                  <td>
                    <b-button size="sm" variant="danger" class="btn-sm" @click="deleteA(item.id,'headline_category')" v-b-tooltip.hover title="Delete"><i class="fa fa-trash"></i></b-button>
                  </td>
                </tr>
              </tbody>
          </table>
        </div>
        <square v-if="isLoading"></square>
       
      </b-card>
      </transition>
    </b-col>
    
    <b-modal title="Alert" size="sm" class="modal-danger" v-model="deleteModal" @ok="deleteAction()" ok-variant="danger">
      Are you sure want to delete?
    </b-modal>

    <b-modal title="Alert" size="lg" class="modal-info" v-model="menuModal"  ok-variant="danger" hide-footer hide-header>
      <Cat-modal @select="saveHeadline"></Cat-modal>
    </b-modal>
    <b-modal title="Alert" size="lg" class="modal-info" v-model="postModal" ok-variant="danger" hide-footer hide-header>
      <C-modal @select="saveHeadline"></C-modal>
    </b-modal>
  </b-row>
</template>

<script>

//import usersData from './ContentModal'

import  ContentModal from '../content/ContentModal.vue';
import  CategoryModal from '../content/CategoryModal.vue';
export default {
  name: 'Headline',
  components: {
      'C-modal':ContentModal,
      'Cat-modal':CategoryModal
   },
  mounted() {
    this.getDatas();
    this.msg = this.$route.query.msg;
    this.msg_type = this.$route.query.msg_type;
  },
  props: {
    caption: {
      type: String,
      default: 'Headline'
    }
  },
  data: () => {
    return {
      items: {
        Headline:[],
        Headline_category:[],
      },
      type:'headline',
      currentPage: 1,
      totalRows: 0,
      limit:10,
      q:'',
      deleteModal:false,
      menuModal:false,
      postModal:false,
      isLoading:true,
      id:'',
      order:'',
      msg:'',
      msg_type:'',
    }
  },
  computed: {
  },
  watch: {

  },
  methods: {
    deleteA(id, type){
      this.deleteModal = true;
      this.id = id;
      this.type = type;
    },
    getNumber(index){
      return (parseInt(index)+1) +((parseInt(this.currentPage)-1) *parseInt(this.limit));
    },
    deleteAction(){
      var app = this;
      var url = this.end_point+'headline/'+this.id+'?type='+this.type;
      axios.delete(url, {type:this.type})
      .then(function (resp) {
        console.log(resp);
        
          app.error = false;
          app.$notify.success(resp.data.msg);
          app.getDatas();
      })
      .catch(function (resp) {
          //app.$notify.error(app.setting.msg_con);
          app.error = true;
      });
    },
    getDatas(){
      var app = this;
      
      this.isLoading = true;
      axios.get(this.end_point+'headline')
      .then(function (resp) {
        app.isLoading = false;
          if(resp.data.error){          
            app.$notify.error('Could not load data ');

            return false;
          }
          //console.log(resp.data);
          app.items = resp.data;
      })
      .catch(function (resp) {
          app.isLoading = false;
          //console.log(resp);
          app.$notify.error('Could not load data ');
      });
    },
    saveHeadline(item){
      this.menuModal = false;
      this.postModal = false;
      var app = this;
      this.isLoading = true;
      axios.post(this.end_point+'headline',{id:item.id,type:item.type_h})
      .then(function (resp) {
        app.isLoading = false;
          app.getDatas();
      })
      .catch(function (resp) {
          app.isLoading = false;
          //console.log(resp);
          // app.$notify.error('Could not load data ');
      });
    },
    alert(pesan) {
      this.$notify.error('Could not load data ');
    },

  }
}
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
</style>
